<script>

/*
    TODO:
    - options:
      where to take edge label (default: ?edgeLabel)
      where to take node color (default: ?rgb, or a color property)
    - highlight links on hover
*/

import { onMount } from "svelte";
import ForceGraph from "force-graph";

import { valueType } from '../Utils.js';

let { results } = $props();
let chart = null;
let zoom = 1;

onMount(() => {
    let nodes = {};
    let links = {};
    let rows = [];
    let node = {};
    let edge = {};

    results.results.bindings.forEach((item, index) => {
        Object.keys(item).forEach((key) => {
            let field = item[key];

            if (!field || !field.value) {
                return;
            }

            let type = valueType(item[key]);

            if (type == 'uri') {
                let label = item[key + 'Label'] && item[key + 'Label'].value || field.value;
                let nodeId = field.value;

                node = {
                    id: nodeId,
                    name: label,
                };

                if (rows[index]) {
                    edge = {
                        source: rows[index],
                        target: nodeId,
                    };

                    links[edge.source + edge.target] = edge;
                    if (!nodes[nodeId]) {
                        nodes[nodeId] = node;
                    }
                }
                else {
                    nodes[nodeId] = node;
                    rows[index] = node.id;
                }
            }
            else if (type == 'image') {
                if (node) {
                    const img = new Image();
                    img.src = field.value;
                    node.image = img;
                }
            }
        });
    });

    nodes = Object.values(nodes);
    links = Object.values(links);

    const chart = new ForceGraph(document.getElementById('chart'))
        .d3AlphaDecay(0)
        .d3VelocityDecay(0.08)
        .cooldownTime(30000)
        .linkColor(() => 'rgba(0, 0, 0, 0.1')
        .zoom(1)
        .nodeCanvasObject((node, ctx, globalScale) => {
            if (node.image) {
                try {
                    const size = 20;
                    ctx.drawImage(node.image, node.x - size / 2, node.y - size / 2, size, size);
                    return;
                }
                catch (error) {
                    console.log('Failed to draw image: ' + error);
                    node.image = null;
                }
            }

            const label = node.name;
            const fontSize = 12 / globalScale;
            ctx.font = `${fontSize}px Sans-Serif`;
            ctx.fillStyle = '#000';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillStyle = node.color;
            ctx.fillText(label, node.x, node.y);
        })
        .graphData({
            nodes,
            links,
        });
});

</script>

<style>

#chart {
    width: 100%;
    height: 90vh;
}

</style>

<div id="chart"></div>
